/* jshint ignore:start */
module.exports = window;
/* jshint ignore:end */